import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

import Checkbox from '../../../../../common/Checkbox';
import * as shapes from '../../shapes';

const CustomReportMetric = ({
  metric,
  index,
  canToggleMetricBreakdown,
  toggleMetricBreakdown,
  toggleMetric,
}) => (
  <Draggable draggableId={metric.metricId} index={index}>
    {provided => (
      <div
        key={metric.metricId}
        className="c-custom-report-metric u-mt--"
        ref={provided.innerRef}
        {...provided.draggableProps}
      >
        {/* eslint-disable jsx-a11y/no-static-element-interactions */}
        <div
          className="c-custom-report-metric__label"
          {...provided.dragHandleProps}
          onClick={toggleMetric(metric.metricId)}
        >
          {metric.displayLabel}
        </div>
        <div display-if={metric.allowBreakdown} className="u-mt--">
          <div className="c-custom-report-metric__connector" />
          <Checkbox
            label={metric.breakdownLabel}
            disabled={!canToggleMetricBreakdown}
            checked={metric.breakdownSelected}
            onChange={toggleMetricBreakdown(metric.metricId)}
          />
        </div>
      </div>
    )}
  </Draggable>
);

CustomReportMetric.propTypes = {
  metric: shapes.reportMetric.isRequired,
  index: PropTypes.number.isRequired,
  canToggleMetricBreakdown: PropTypes.bool,
  toggleMetricBreakdown: PropTypes.func,
  toggleMetric: PropTypes.func,
};

CustomReportMetric.defaultProps = {
  canToggleMetricBreakdown: false,
  toggleMetricBreakdown: () => null,
  toggleMetric: () => null,
};

export default CustomReportMetric;
